<template>
  <div class="addMessageType">
    <!--新增-->
    <el-dialog
      :title="$t('warehouseContract.form.disabledTitle')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="500px"
    >
      <el-form
        label-width="auto"
        :rules="rules"
        :model="addList"
        ref="addList"
        :label-position="'right'"
      >
        <el-form-item prop="editReason" :label="$t('warehouseContract.form.disabledReason')">
          <el-input
            v-model="addList.editReason"
            :placeholder="$t('warehouseContract.form.disabledReasonPlaceholder')"
            type="textarea"
            :rows="3"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAdd = false">{{ $t('dialog.cancel') }}</el-button>
        <el-button type="primary" @click="addSure()">{{ $t('dialog.save') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/logisticsCenter/warehouseContract.js';
  export default {
    name: 'disabledReson',
    data() {
      return {
        dialogAdd: false,
        addList: {
          editReason: '',
        },
        formData: {},
        contractType: '',
        rules: {
          editReason: [
            {
              required: true,
              message: this.$t('warehouseContract.form.disabledReasonPlaceholder'),
              trigger: 'blur',
            },
          ],
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    methods: {
      openDialog(flag, data, type) {
        if (this.$refs['addList']) {
          this.$refs['addList'].resetFields();
        }
        this.formData = data;
        this.contractType = type;
        if (this.userInfo.userInfo.adminFlag == 1) {
          this.dialogAdd = false;
          this.adminSure();
        } else {
          this.dialogAdd = flag;
        }
      },
      //保存
      addSure() {
        this.$refs.addList.validate((valid) => {
          if (valid) {
            this.adminSure();
          } else {
            return false;
          }
        });
      },
      adminSure() {
        let msg = this.$t('confirm.forbid');
        let content = this.$t('confirm.forbidContent');
        this.$confirmAction(msg, content)
          .then(() => {
            let params = {
              admin: this.userInfo.userInfo.adminFlag,
              contractType: this.contractType,
              version: this.formData.version,
              contractNo: this.formData.contractNo,
              contractUpdatePersonName: this.userInfo.userInfo.userName,
              editReason: this.addList.editReason,
              contractStatus: 'ZT04',
            };
            this.$axios.post(API.DELETE_CONTRACT_API, params).then((res) => {
              if (0 == res.data.code) {
                //如果操作成功，直接返回列表
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                this.dialogAdd = false;
                let detailName = '';
                let listName = '';
                if (this.contractType == '01') {
                  detailName = 'wareHouseContractDetail';
                  listName = 'wareHouseContractList';
                } else if (this.contractType == '02') {
                  detailName = 'logisticsContractDetail';
                  listName = 'logisticsContractList';
                } else if (this.contractType == '03') {
                  detailName = 'wharfOperationContractDetail';
                  listName = 'wharfOperationContractList';
                } else {
                  detailName = 'transportContractDetail';
                  listName = 'transportContractList';
                }
                let path = {
                  fromPath: {
                    path: '/logistics/' + detailName,
                    name: detailName,
                    meta: {
                      keepAlive: true,
                    },
                  },
                  toPath: {
                    path: '/logistics/' + listName,
                    name: listName,
                    meta: {
                      keepAlive: false,
                    },
                  },
                };
                this.$store.dispatch('tagsView/backTabView', path).then(() => {
                  this.$nextTick(() => {
                    this.$router.push(path.toPath);
                  });
                });
              } else {
                //如果有错误返回，提示信息
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
    },
  };
</script>
